import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { context } from '../../../../globalState/GlobalState';
import './css/GameWidget1.css';
import DemoLogo from '../../../../assets/demoOpponentTeam.png';
import { isValidObject, isValidString } from '../../../../catalog/Validity';
import { getLocalTimeFromDatabaseTime } from '../../../../catalog/DateTime';
import { opponentGoalsFromGame as opponentIceHockeyGoalsFromGame, ourGoalsFromGame as ourIceHockeyGoalsFromGame } from '../../../../catalog/stats/iceHockey/IceHockeyGameStats';
import { opponentGoalsFromGame as opponentLacrosseGoalsFromGame, ourGoalsFromGame as ourLacrosseGoalsFromGame } from '../../../../catalog/stats/lacrosse/LacrosseGameStats';
import { SportsType } from '../../../../catalog/enums/SportsType';
import { opponentPointsFromGame, ourPointsFromGame } from '../../../../catalog/stats/rugby/RugbyGameStats';

const GameWidget1 = (props) => {
    const { id, game, opponentName, opponentLogo, status, homeGame, timeOfGame } = props;
    const { globalState } = useContext(context);
    const history = useHistory();

    // eslint-disable-next-line no-unused-vars
    const isUpcomingGame = () => {
        if (isValidObject(timeOfGame) && isValidObject(timeOfGame.seconds)) {
            return getLocalTimeFromDatabaseTime(timeOfGame) > new Date();
        }
        return true;
    };

    const getScore = (home) => {
        if (status === 'postponed') {
            return 'Postponed';
        }
        if (status === 'cancelled') {
            return 'Cancelled';
        }
        if (status === 'tba' || status === 'tbat' || status === 'scheduled') {
            return '- vs -';
        }
        if (home) {
            if (globalState.sportsType === SportsType.WOMENSICEHOCKEY || globalState.sportsType === SportsType.MENSICEHOCKEY) {
                return `${ourIceHockeyGoalsFromGame(game)} - ${opponentIceHockeyGoalsFromGame(game)}`;
            }
            if (globalState.sportsType === SportsType.WOMENSRUGBY || globalState.sportsType === SportsType.MENSRUGBY) {
                return `${ourPointsFromGame(game)} - ${opponentPointsFromGame(game)}`;
            }
            if (globalState.sportsType === SportsType.WOMENSLACROSSE || globalState.sportsType === SportsType.MENSLACROSSE) {
                return `${ourLacrosseGoalsFromGame(game)} - ${opponentLacrosseGoalsFromGame(game)}`;
            }
        }
        if (globalState.sportsType === SportsType.WOMENSICEHOCKEY || globalState.sportsType === SportsType.MENSICEHOCKEY) {
            return `${opponentIceHockeyGoalsFromGame(game)} - ${ourIceHockeyGoalsFromGame(game)}`;
        }
        if (globalState.sportsType === SportsType.WOMENSRUGBY || globalState.sportsType === SportsType.MENSRUGBY) {
            return `${opponentPointsFromGame(game)} - ${ourPointsFromGame(game)}`;
        }
        if (globalState.sportsType === SportsType.WOMENSLACROSSE || globalState.sportsType === SportsType.MENSLACROSSE) {
            return `${opponentLacrosseGoalsFromGame(game)} - ${ourLacrosseGoalsFromGame(game)}`;
        }
        return '- vs -';
    };

    return (
        <div>
            {!homeGame ? (
                <div className="game-widget1 box-shadow-black curve-border-20px m-t-20px m-b-20px p-t-30px p-b-30px p-l-20px p-r-20px x-center">
                    <div className="game-widget1-logo-container">
                        <img className="game-widget1-logo" src={globalState.logo.logo2} alt={globalState.teamAlias} />
                    </div>
                    <div>
                        <p className="game-widget1-score m-t-50px m-b-0 m-l-5px m-r-5px font-size-6xl p-l-10px p-r-10px curve-border-5px">
                            {getScore(true)}
                        </p>
                        <button className="game-widget1-view-game m-t-20px m-b-0" onClick={() => { history.push(`/games/${id}/info`); }} type="button">View Game</button>
                    </div>
                    <div className="game-widget1-logo-container">
                        <img className="game-widget1-logo" src={isValidString(opponentLogo) ? opponentLogo : DemoLogo} alt={opponentName} />
                    </div>
                </div>
            ) : (
                <div className="game-widget1 box-shadow-black curve-border-20px m-t-20px m-b-20px p-t-30px p-b-30px p-l-20px p-r-20px x-center">
                    <div className="game-widget1-logo-container">
                        <img className="game-widget1-logo" src={isValidString(opponentLogo) ? opponentLogo : DemoLogo} alt={opponentName} />
                    </div>
                    <div>
                        <p className="game-widget1-score m-t-50px m-b-0 m-l-5px m-r-5px font-size-6xl p-l-10px p-r-10px curve-border-5px">
                            {getScore(false)}
                        </p>
                        <button className="game-widget1-view-game m-t-20px m-b-0" onClick={() => { history.push(`/games/${id}/info`); }} type="button">View Game</button>
                    </div>
                    <div className="game-widget1-logo-container">
                        <img className="game-widget1-logo" src={globalState.logo.logo2} alt={globalState.teamAlias} />
                    </div>
                </div>
            )}
        </div>
    );
};

GameWidget1.propTypes = {
    id: PropTypes.string.isRequired,
    game: PropTypes.object.isRequired,
    opponentName: PropTypes.string.isRequired,
    opponentLogo: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    homeGame: PropTypes.bool.isRequired,
    timeOfGame: PropTypes.object.isRequired,
};

export default memo(GameWidget1);
